const MATCH_SOUNDCLOUD_URL = /^https?:\/\/(www\.)?(on\.)?soundcloud\.com\/(.)+(\/(.)+)?/;
const isSoundcloudUrl = (url) => MATCH_SOUNDCLOUD_URL.test(url);
export {
  isSoundcloudUrl
};
//# sourceMappingURL=utils.js.map
